var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"btn-ims--go-top",attrs:{"title":_vm.title,"size":_vm.size,"type":_vm.type},on:{"click":_vm.scrollTo}},[_c('arrow-icon'),(_vm.label !== '')?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }